var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "button px-3 rounded-lg flex items-center text-white text-sm font-bold transition",
      class: `color-${_vm.color} hover-color-${_vm.hoverColor}`,
      staticStyle: { height: "48px" },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _vm.download
        ? _c(
            "div",
            {
              staticClass:
                "flex justify-center items-center pointer-events-none",
              staticStyle: { width: "24px", height: "48px" },
            },
            [
              _c("img", {
                attrs: {
                  width: "24",
                  height: "24",
                  src: require("@/assets/images/meeting-note/download_white.svg"),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }